import { useOutletContext } from "react-router"
import { AutomationSchedulesList } from "../../../../Automations/Schedules"
import { TAutomation } from "../../../../Automations/store"

export default function AutomationSchedulesPage() {
	const context = useOutletContext<{
		automationId: string
		automation: TAutomation
	}>()

	return (
		<AutomationSchedulesList
			automationIds={[Number(context.automationId)]}
			title="Schedules"
		/>
	)
}
